import React from 'react'

type Variant = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'default'
type Size = 'sm' | 'md' | 'lg'

interface BadgeProps {
  variant?: Variant
  size?: Size
  className?: string
  children?: React.ReactNode
}

export function Badge({ variant = 'default', size = 'sm', className = '', children }: BadgeProps) {
  const variantClass: Record<Variant, string> = {
    primary: 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300',
    success: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400',
    warning: 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400',
    danger:  'bg-rose-50 text-rose-700 dark:bg-rose-900/20 dark:text-rose-400',
    info:    'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
    default: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
  }

  const sizeClass =
    size === 'sm' ? 'text-xs font-semibold tabular-nums px-2 py-0.5 rounded-full'
    : size === 'md' ? 'text-sm font-semibold tabular-nums px-3 py-1 rounded-full'
    : 'text-base font-semibold tabular-nums px-4 py-1.5 rounded-full'

  return (
    <span className={`${sizeClass} ${variantClass[variant]} ${className}`.trim()}>
      {children}
    </span>
  )
}

export default Badge
